const listaDeAnaliticosProvedor = (state) => state.items

const loadingAnaliticosProvedor = (state) => state.carregando

const paginacao = (state) => state.paginacao || null

export {
  listaDeAnaliticosProvedor,
  loadingAnaliticosProvedor,
  paginacao
}
